import * as types from '../constants/ActionTypes';
import { MOVE_TO_NEXT_EVENT } from './gameActions'

export function selectPlayer(playerId, select = true) {
    return {
        type: types.SELECT_PLAYER,
        playerId,
        select
    };
}

export function selectManager(home, select = true) {
    return {
        type: types.SELECT_MANAGER,
        home,
        select
    };
}

export function startGame() {
    return {
        type: types.START_GAME
    };
}

export function pauseGame() {
    return {
        type: types.PAUSE_GAME
    };
}

export function requestReplay() {
    return {
        type: types.REQUEST_REPLAY
    };
}

export function speed_up_Game(step) {
    return {
        type: types.SPEED_UP_GAME,
        step: step
    };
}

export function slow_down_Game(step) {

    return {
        type: types.SLOW_DOWN_GAME,
        step: step
    };
}

export function set_game_speed(gameSpeed) {
    
        return {
            type: types.SET_GAME_SPEED,
            gameSpeed: gameSpeed
        };
    }

export function move_to_minute(minute) {

    return {
        type: types.MOVE_TO_MINUTE,
        minute
    };

}

export function toggle_sound() {
    return {
        type: types.TOGGLE_SOUND
    };
}

export function move_to_next_episod() {
    return {
        type: types.MOVE_TO_NEXT_EPISOD
    };
}

export function move_to_prev_episod() {
    return {
        type: types.MOVE_TO_PREV_EPISOD
    };
}


/** WEBPACK FOOTER **
 ** ./src/actions/UserActions.js
 **/